<section
  #scrollContainer
  class="flex min-h-full max-h-full w-full flex-col overflow-auto"
>
  <div class="relative">
    <app-main-header />
    <div
      class="pointer-events-none absolute inset-x-0 top-full z-50 h-1 transition-opacity duration-200"
      role="progressbar"
      aria-label="Loading page"
      aria-valuemin="0"
      aria-valuemax="100"
      [attr.aria-valuenow]="navigationCompleting() ? 100 : 80"
      [class.opacity-100]="navigationInProgress()"
      [class.opacity-0]="!navigationInProgress()"
    >
      <div
        class="h-full bg-[#2192BA] transition-all duration-200 ease-out"
        [class.w-0]="!navigationInProgress()"
        [class.w-4/5]="navigationInProgress() && !navigationCompleting()"
        [class.w-full]="navigationCompleting()"
      ></div>
    </div>
  </div>
  <main class="min-h-fit grow">
    <router-outlet />
  </main>
  <app-main-footer />
</section>
